// #genai Phase 2 shared add-payment-method button barrel export.
import AddPaymentMethodButton from './AddPaymentMethodButton.component';

export default AddPaymentMethodButton;
